// extracted by mini-css-extract-plugin
module.exports = {"team_cardStyle":"styles_team_cardStyle__16ZsX"};